import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const formatRegisterData = (dataWeb, user, namePanel, fechaRegistro) => {
    const normalizeDate = (fecha) => {
        if (!fecha) return ' ';

        if (dayjs(fecha, "DD-MM-YYYY", true).isValid()) {
            return dayjs(fecha, "DD-MM-YYYY").format("YYYY-MM-DD");
        }

        if (dayjs(fecha, "YYYY-MM-DD", true).isValid()) {
            return fecha;
        }

        return ' ';
    };

    try {
        
        const trimmedData = Object.fromEntries(
            Object.entries(dataWeb).map(([key, value]) => [key, typeof value === 'string' ? value === ' ' ? value : value.trim() : value])
        );
        const camposCompletos = {
            user,
            namePanel,
            fechaRegistro,

            disparo1Tajo: trimmedData.disparo1Tajo ? trimmedData.disparo1Tajo : trimmedData.disparo2Tajo ? ' ' : 'SIN -',
            
            disparo1Nivel: trimmedData.disparo1Tajo ? trimmedData.disparo1Nivel : ' ',
            disparo1Hora: trimmedData.disparo1Tajo ? trimmedData.disparo1Hora : ' ',

            disparo2Tajo: trimmedData.disparo2Tajo ? trimmedData.disparo2Tajo : trimmedData.disparo1Tajo ? ' ' : 'DISP ARO',
            disparo2Nivel: trimmedData.disparo2Tajo ? trimmedData.disparo2Nivel : ' ',
            disparo2Hora: trimmedData.disparo2Tajo ? trimmedData.disparo2Hora : ' ',

            fecha: normalizeDate(trimmedData.fecha),
        }
        return camposCompletos
    } catch (error) {
        console.error('Error en formatData:', error);
        return {};
    }
}
